import React, { useState, useEffect } from 'react';
import { isCodespaces, getCodespacesStore, setCodespacesStore } from '../utils/subdomain';
import apiService from '../services/apiService';

const CodespacesStoreSelector = () => {
    const [stores, setStores] = useState({});
    const [currentStore, setCurrentStore] = useState(getCodespacesStore());
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadStores();
    }, []);

    const loadStores = async () => {
        try {
            const storesData = await apiService.getStores();
            setStores(storesData);
        } catch (error) {
            // Fallback: usar LOJAS_CONFIG do env se disponível
            setStores({});
        } finally {
            setLoading(false);
        }
    };

    const handleStoreChange = (e) => {
        const store = e.target.value;
        setCodespacesStore(store || null);
        setCurrentStore(store);
        // Recarregar para aplicar o novo subdomínio
        window.location.reload();
    };

    if (!isCodespaces()) return null;
    if (loading) return null;

    const storeEntries = Object.entries(stores).filter(([key]) => key !== 'default');

    return (
        <div style={{
            background: '#1a1a2e',
            color: '#e0e0e0',
            padding: '6px 16px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            fontSize: '13px',
            borderBottom: '1px solid #333',
            zIndex: 9999
        }}>
            <span style={{ opacity: 0.7 }}>🔧 Codespaces</span>
            <select
                value={currentStore || ''}
                onChange={handleStoreChange}
                style={{
                    background: '#2a2a4a',
                    color: '#fff',
                    border: '1px solid #555',
                    borderRadius: '4px',
                    padding: '3px 8px',
                    fontSize: '13px',
                    cursor: 'pointer'
                }}
            >
                <option value="">-- Selecione a loja --</option>
                {storeEntries.map(([key, name]) => (
                    <option key={key} value={key}>{name} ({key})</option>
                ))}
            </select>
            {currentStore && (
                <span style={{ opacity: 0.5 }}>
                    Subdomínio ativo: <strong style={{ color: '#4fc3f7' }}>{currentStore}</strong>
                </span>
            )}
        </div>
    );
};

export default CodespacesStoreSelector;
